// extracted by mini-css-extract-plugin
export var cardIcon = "_6j-5";
export var cardIconUnframed = "_6j-9";
export var checkboxCard = "_6j-0";
export var checkboxCardSelected = "_6j-4";
export var disabled = "_6j-2";
export var interactive = "_6j-1";
export var outerBorder = "_6j-3";
export var spacerMedium = "_6j-8";
export var spacerSmall = "_6j-7";
export var spacerXsmall = "_6j-6";